import {
  Component,
  OnInit,
  Input,
  Inject,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  FormControl,
  Validators,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { CookieService } from "ngx-cookie-service";
import { VolvoApiService } from "../../../../services/volvo-api.service";
import { MatDialogRef } from "@angular/material";
import { FormControlService } from "../../../../services/form-control.service";
import { Observable, throwError } from "rxjs";
import { FormFieldDropdown } from "../../../../models/form-field-dropdown";
import { PageConfiguration } from "../../../../models/page-configuration";

@Component({
  selector: "app-registration-sponsor",
  templateUrl: "./registration-sponsor.component.html",
  styleUrls: ["./registration-sponsor.component.scss"],
})
export class RegistrationSponsorComponent implements OnInit {
  @Input() Guid: string;
  @Input() AdditionalFieldsFormID: number;
  @Input() CountryID: number;
  @Input() localStrings: Array<any>;
  @Input() pageConfig: PageConfiguration;
  @Input() promotionAlias: string;
  @Input() isHotelPromotion: boolean;

  regForm: FormGroup;
  regSonsorForm: FormGroup;
  offerFormRowFields = [];
  sponsorFormRowFields = [];
  private extraFields = [];
  private extraFormRowFields: Array<any>;
  private partners: Observable<any>;
  private states: Observable<any>;
  private partnerDropdown: FormFieldDropdown;
  private stateDropdown: FormFieldDropdown;
  private referredStateDropdown: FormFieldDropdown;
  errorMessages: Array<any>;
  public formSubmitAttempt: boolean;
  public termsExpanded: boolean = false;
  urlBase: string;
  submitSuccess = false;

  showPreferredDealers = false;
  loadingDealers = false;
  noDealersFound = false;
  nearbyDealers: any = [];
  nearbyDealersLimit = 3;

  constructor(
    private volvoApi: VolvoApiService,
    private dialogRef: MatDialogRef<RegistrationSponsorComponent>,
    private _fb: FormBuilder,
    private _fs: FormControlService,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    this.urlBase = this.urlBase = `${this.isHotelPromotion ? "/hotel" : ""}/${
      this.promotionAlias
    }`;

    console.log(this.isHotelPromotion);
    console.log(this.promotionAlias);

    // create form
    const ls = this.localStrings;

    // partner dropdown
    const partnerValidationText =
      this.pageConfig.PartnerCodeSelectValidationText != ""
        ? this.pageConfig.PartnerCodeSelectValidationText
        : ls["AV.Promotions.lb.validation.partnerCode"];
    this.partnerDropdown = this._fs.createDropDownField(
      "partnerCode",
      null,
      null,
      Validators.required,
      partnerValidationText,
      partnerValidationText
    );
    this.offerFormRowFields.push([this.partnerDropdown]);

    // add the fleet company and
    // fleet VIN fields to the form
    if(this.pageConfig.Format === `fleet`) {

      Array.prototype.push.apply(
        this.offerFormRowFields,
        this._fs.getFleetPinFields(ls)
      );

    }

    // add the red sox fields to the form
    if(this.pageConfig.Format === `redsox`) {

      Array.prototype.push.apply(
        this.offerFormRowFields,
        this._fs.getRedSoxPinFields(ls)
      );

    }

    Array.prototype.push.apply(
      this.offerFormRowFields,
      this._fs.getBasicInfoFields(ls, null, this.pageConfig.Format)
    );

    // state and zip code
    this.stateDropdown = this._fs.createDropDownField(
      "state",
      "column medium-6 form-control-wrapper",
      null,
      Validators.required,
      ls["AV.Promotions.lb.stateID"],
      ls["AV.Promotions.lb.stateID"]
    );

    const zipCodeField = this._fs.createTextBox(
      "zipcode",
      ls["AV.Promotions.lb.zipcode"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.zipcode"],
      ls["AV.Promotions.lb.validation.zipcode.invalid"],
      [
        Validators.required,
        this._fs.patternValidator(
          /(^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]( )?\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]\d$)|(^\d{5}(-\d{4})?$)/
        ),
      ]
    );

    this.offerFormRowFields.push([this.stateDropdown, zipCodeField]);

    // email and phone number
    const emailField = this._fs.createTextBox(
      "email",
      ls["AV.Promotions.lb.emailAddress"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.fromAddress"],
      ls["AV.Promotions.lb.validation.emailAddress.invalid"],
      [Validators.required, Validators.email]
    );
    const phoneField = this._fs.createTextBox(
      "phone",
      ls["AV.Promotions.lb.phoneNumber"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.phoneNumber"],
      ls["AV.Promotions.lb.validation.phoneNumber.invalid"],
      [
        Validators.required,
        this._fs.patternValidator(
          /^(1[-. ]?)?(\([2-9]\d{2}\)|[2-9]\d{2})[-. ]?[2-9]\d{2}[-. ]?\d{4}(([xX]|ext|EXT)?\d{1,5})?$/
        ),
      ]
    );
    this.offerFormRowFields.push([emailField, phoneField]);

    // Referred Member Info

    const referredFirstname = this._fs.createTextBox(
      "referredFirstname",
      ls["AV.Promotions.lb.referredFirstname"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.referredFirstname"],
      ls["AV.Promotions.lb.validation.referredFirstname"],
      Validators.required
    );

    const referredLastname = this._fs.createTextBox(
      "referredLastname",
      ls["AV.Promotions.lb.referredLastname"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.referredLastname"],
      ls["AV.Promotions.lb.validation.referredLastname"],
      Validators.required
    );
    this.sponsorFormRowFields.push([referredFirstname, referredLastname]);

    const referredAddress = this._fs.createTextBox(
      "referredAddress",
      ls["AV.Promotions.lb.referredAddress"],
      null,
      null,
      null,
      ls["AV.Promotions.lb.validation.referredAddress"],
      ls["AV.Promotions.lb.validation.referredAddress"],
      Validators.required
    );
    this.sponsorFormRowFields.push([referredAddress]);

    const referredCity = this._fs.createTextBox(
      "referredCity",
      ls["AV.Promotions.lb.referredCity"],
      null,
      null,
      40,
      ls["AV.Promotions.lb.validation.referredCity"],
      ls["AV.Promotions.lb.validation.referredCity"],
      Validators.required
    );
    this.sponsorFormRowFields.push([referredCity]);

    // state and zip code
    this.referredStateDropdown = this._fs.createDropDownField(
      "referredState",
      "column medium-6 form-control-wrapper",
      null,
      Validators.required,
      ls["AV.Promotions.lb.validation.referredStateID"],
      ls["AV.Promotions.lb.referredStateID"]
    );

    const referredZipCodeField = this._fs.createTextBox(
      "referredZipcode",
      ls["AV.Promotions.lb.referredZipcode"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.referredZipcode"],
      ls["AV.Promotions.lb.validation.zipcode.invalid"],
      [
        Validators.required,
        this._fs.patternValidator(
          /(^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]( )?\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]\d$)|(^\d{5}(-\d{4})?$)/
        ),
      ]
    );
    this.sponsorFormRowFields.push([
      this.referredStateDropdown,
      referredZipCodeField,
    ]);

    // email and phone number
    const referredEmailField = this._fs.createTextBox(
      "referredEmail",
      ls["AV.Promotions.lb.referredEmail"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.referredEmail"],
      ls["AV.Promotions.lb.validation.emailAddress.invalid"],
      [Validators.required, Validators.email]
    );
    const referredPhoneField = this._fs.createTextBox(
      "referredPhone",
      ls["AV.Promotions.lb.referredPhone"],
      null,
      "column medium-6 form-control-wrapper",
      null,
      ls["AV.Promotions.lb.validation.referredPhone"],
      ls["AV.Promotions.lb.validation.phoneNumber.invalid"],
      [
        Validators.required,
        this._fs.patternValidator(
          /^(1[-. ]?)?(\([2-9]\d{2}\)|[2-9]\d{2})[-. ]?[2-9]\d{2}[-. ]?\d{4}(([xX]|ext|EXT)?\d{1,5})?$/
        ),
      ]
    );
    this.sponsorFormRowFields.push([referredEmailField, referredPhoneField]);

    const pinTypes = [{
      key: '',
      value: ls["AV.Promotions.lb.programOption.required"],
      selected: true,
      disabled: true
    }];
    this.pageConfig.ProgramType.forEach(item => {
      pinTypes.push({
        key: item.ProgramTypeCode,
        value: item.ProgramTypeDescription,
        selected: false,
        disabled: false
      });
    });

    const pinTypeDropdown = this._fs.createDropDownField(
      "programOption",
      "",
      pinTypes,
      Validators.required,
      ls["AV.Promotions.lb.programOption.required"],
      ls["AV.Promotions.lb.programOption"],
      ls["AV.Promotions.lb.programOptionDescription"]);
    this.sponsorFormRowFields.push([pinTypeDropdown]);

    if (this.pageConfig.PromotionHidePrefContact == false) {
      // preferred method
      const methodOptions = [
        {
          label: ls["AV.Promotions.lb.contactMethodPhone"],
          value: "phone",
          checked: false,
        },
        {
          label: ls["AV.Promotions.lb.contactMethodEmail"],
          value: "email",
          checked: false,
        },
        // {
        //   label: ls["AV.Promotions.lb.contactMethodSMS"],
        //   value: "sms",
        //   checked: false,
        // },
        {
          label: ls["AV.Promotions.lb.contactMethodDoNotContact"],
          value: "doNotContact",
          checked: false,
        },
      ];
      const preferredMethodField = this._fs.createRadioField(
        "preferredContactMethod",
        ls["AV.Promotions.lb.contactMethod"],
        "",
        null,
        methodOptions,
        Validators.required,
        ls["AV.Promotions.lb.contactMethod.required"],
        this.pageConfig.PromotionPreferredContactText
      );
      this.sponsorFormRowFields.push([preferredMethodField]);
    }

    // load partners dropdown list
    this.partners = this.volvoApi.getAvailablePartnersSponsor(this.Guid);
    this.partners.subscribe((r) => {
      const selectLabel =
        this.pageConfig.PartnerCodeSelectText != ""
          ? this.pageConfig.PartnerCodeSelectText
          : ls["AV.Promotions.lb.partnerSelectText"];

      this.partnerDropdown.options = this._fs.createOptionsObj(
        r,
        "Code",
        selectLabel
      );

      // select and hide dropdown if there is only one partner
      if (r.length == 1) {
        this.partnerDropdown.options[1].selected = true;
        this.regForm.controls["partnerCode"].setValue(
          this.partnerDropdown.options[1].key
        );
        this.partnerDropdown.cssClasses += " hide";
      }
    });

    // load states dropdown list
    this.states = this.volvoApi.getStates(this.CountryID);
    this.states.subscribe((r) => {
      this.stateDropdown.options = this._fs.createOptionsObj(
        r,
        "Id",
        ls["AV.Promotions.lb.stateID"]
      );
      this.referredStateDropdown.options = this._fs.createOptionsObj(
        r,
        "Id",
        ls["AV.Promotions.lb.referredStateID"]
      );
    });

    // load additional fields
    if (this.AdditionalFieldsFormID != 0) {
      this.volvoApi.getAdditionalFields("en-US", this.Guid).subscribe(
        (r) => {
          this.extraFormRowFields = this._fs.generateFormRows(r, true);
          this.extraFields.push({
            Name: r.form.field[0].column[0],
          });
          Array.prototype.push.apply(
            this.sponsorFormRowFields,
            this.extraFormRowFields
          );
          this.createForm();
        },
        (e) => console.error(e)
      );
    } else {
      this.createForm();
    }

    this.createForm();
  }

  get optin() {
    return this.regSonsorForm.get("optin");
  }
  get agreeterm() {
    return this.regSonsorForm.get("agreeterm");
  }
  get agreeterm_sponsor() {
    return this.regSonsorForm.get("agreeterm_sponsor");
  }
  get preferredDealerID() {
    return this.regSonsorForm.get("preferredDealerID");
  }

  createForm() {
    this.regForm = this._fs.toFormGroup(this.offerFormRowFields);

    this.regSonsorForm = this._fs.toFormGroup(this.sponsorFormRowFields);

    // console.table(this.regForm);

    // register static form control fields
    this.regSonsorForm.addControl(
      "optin",
      new FormControl("", Validators.nullValidator)
    );
    this.regSonsorForm.addControl(
      "agreeterm",
      new FormControl("", Validators.requiredTrue)
    );
    this.regSonsorForm.addControl(
      "agreeterm_sponsor",
      new FormControl("", Validators.requiredTrue)
    );
    this.regSonsorForm.addControl(
      "preferredDealerID",
      new FormControl("", Validators.required)
    );

    this.regSonsorForm.controls["optin"].setValue(false);

    const idMeInfo = this.cookieService.get("idMeInfo");

    if (this.pageConfig.UseIdMe && idMeInfo !== "") {
      try {
        const idMeInfo_obj = JSON.parse(idMeInfo);
        this.regForm.controls["firstname"].setValue(idMeInfo_obj.FirstName);
        this.regForm.controls["lastname"].setValue(idMeInfo_obj.LastName);
        this.regForm.controls["email"].setValue(idMeInfo_obj.Email);
        this.regForm.controls["zipcode"].setValue(idMeInfo_obj.Zip);
      } catch (error) {
        console.log(error);
        throwError(error);
      }
    }

    this.checkFormValues();
  }

  checkFormValues() {
    // if we have preferred contacts,
    // we need to wait and check
    if (this.pageConfig.PromotionHidePrefContact == false) {
      this.regSonsorForm
        .get("referredZipcode")
        .valueChanges.subscribe((val) => {
          this.checkFieldsForNearestDealer();
        });

      this.regSonsorForm
        .get("preferredContactMethod")
        .valueChanges.subscribe((val) => {
          if (
            val === "doNotContact" ||
            (this.nearbyDealers.length === 0 &&
              !this.noDealersFound &&
              !this.loadingDealers)
          ) {
            this.checkFieldsForNearestDealer();
          }
        });
    } else {
      this.regSonsorForm.get("preferredDealerID").setValue(0);
    }
  }

  checkFieldsForNearestDealer() {
    const _inputContactMethod = this.regSonsorForm.get(
      "preferredContactMethod"
    );
    const _inputAddressZip = this.regSonsorForm.get("referredZipcode");
    const addressZipValid = this.regSonsorForm.get("referredZipcode").valid;
    const contactMethodSelected =
      _inputContactMethod.value !== "" &&
      _inputContactMethod.value !== "doNotContact";

    this.nearbyDealers = [];
    this.showPreferredDealers = false;
    this.noDealersFound = false;
    this.regSonsorForm.get("preferredDealerID").setValue("");

    if (addressZipValid && contactMethodSelected) {
      this.nearestDealerOptions();
    } else {
      if (_inputContactMethod.value === "doNotContact") {
        this.regSonsorForm.get("preferredDealerID").setValue(0);
      }
    }
  }

  nearestDealerOptions() {
    // load states dropdown list
    this.showPreferredDealers = true;
    this.loadingDealers = true;

    let dealers = this.volvoApi.getNearestDealers(
      this.regSonsorForm.get("referredAddress").value,
      this.regSonsorForm.get("referredCity").value,
      this.regSonsorForm.get("referredZipcode").value,
      this.CountryID
    );
    dealers.subscribe((r) => {
      if (r.length === 0) {
        this.noDealersFound = true;
      } else {
        this.nearbyDealers = r;
      }

      this.loadingDealers = false;
    });
  }

  selectNearbyDealer(e) {
    this.regSonsorForm.get("preferredDealerID").setValue(e.target.value);
  }

  showMoreRetailLocations(e) {
    this.nearbyDealersLimit = 6;
  }

  onSubmit() {
    // extra fields value
    this.extraFields.map((e) => {
      return (e["Value"] = this.regSonsorForm.controls[e.Name].value);
    });

    if (this.regForm.valid && this.regSonsorForm.valid) {
      this.formSubmitAttempt = true;
      const formData = { ...this.regForm.value, ...this.regSonsorForm.value };

      formData.promotionGuid = this.Guid;
      formData.culture = this.volvoApi.getCultureCode();

      if (formData.preferredContactMethod == undefined) {
        formData.preferredContactMethod = "";
      }

      formData.extraFields = this.extraFields;
      formData.externalID = "";
      formData.referenceID = "";

      const idMeInfo = this.cookieService.get("idMeInfo");

      if (this.pageConfig.UseIdMe && idMeInfo !== "") {
        try {
          const idMeInfo_obj = JSON.parse(idMeInfo);
          formData.externalID = idMeInfo_obj.UniqueIdentifier;
          formData.referenceID = idMeInfo_obj.ReferenceID;
        } catch (error) {
          console.log(error);
          throwError(error);
        }
      }

      let sponsoredPinRequest = null;

      if(this.pageConfig.Format === `fleet`) {
        // if the page format is `fleet`
        // then we need to create the pin using
        // a specific webservice method
        sponsoredPinRequest = this.volvoApi.CreateFleetSponsorPin(formData);
      }
      else if(this.pageConfig.Format === `redsox`) {
        // if the page format is `redsox`
        // then we need to create the pin using
        // a specific webservice method
        sponsoredPinRequest = this.volvoApi.CreateRedSoxSponsorPin(formData);
      } else {
        // otherwise lets create a normal PIN using
        // the existing CreatePin webservice
        sponsoredPinRequest = this.volvoApi.CreateSponsorPin(formData);
      }

      sponsoredPinRequest.subscribe((r) => {
        if (r.Success) {
          this.formSubmitAttempt = false;
          this.errorMessages = null;
          this.submitSuccess = true;
          setTimeout(() => {
            this.dialogRef.close();
          }, 15000);
        } else {
          this.formSubmitAttempt = false;
          this.errorMessages = r.ErrorMessages;
          console.log("error creating pin");
        }

        if (this.pageConfig.UseIdMe) {
          // delete the cookies so that the user
          // must reauthenicate w/ idme
          this.cookieService.delete("idMeInfo");
          this.cookieService.delete("idMeCode");
        }
      });
    }
  }

  isFieldValid_regForm(field: string) {
    return (
      (!this.regForm.get(field).valid &&
        (this.regForm.get(field).touched || this.regForm.get(field).dirty)) ||
      (this.regForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  isFieldValid_regSonsorForm(field: string) {
    return (
      (!this.regSonsorForm.get(field).valid &&
        (this.regSonsorForm.get(field).touched ||
          this.regSonsorForm.get(field).dirty)) ||
      (this.regSonsorForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  clickTermsExpand() {
    this.termsExpanded = !this.termsExpanded;
  }

  clickSubmit() {
    const regFormValid = this._fs.validateForm(this.regForm);
    const regSonsorFormValid = this._fs.validateForm(this.regSonsorForm);
    if (regFormValid && regSonsorFormValid) {
      this.onSubmit();
    }
  }
}
